/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>短信发送记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">
      <el-form-item label="接收者UID:" prop="accountId">
        <el-input maxlength="10" type="number"  clearable v-model="formInline.accountId"
          placeholder="输入接收者UID"></el-input>
      </el-form-item>

      <el-form-item label="接收者昵称:" prop="nickName">
        <el-input   clearable v-model="formInline.nickName"
          placeholder="输入接收者昵称"></el-input>
      </el-form-item>
      <el-form-item label="接收者手机：" prop="phone">
        <el-input maxlength="11" type="number"  clearable v-model="formInline.phone"
          placeholder="输入接收者手机"></el-input>
      </el-form-item>

      <el-form-item prop="status" label="发送状态:">
        <el-select v-model="formInline.status" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="成功" value="1"></el-option>
          <el-option label="失败" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="type" label="发送类型:">
        <el-select v-model="formInline.type" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="系统通知" value="1"></el-option>
          <el-option label="短信发送" value="2"></el-option>
        </el-select>
      </el-form-item>
     

      <el-form-item   prop="operatorUserId" label="操作人员:">
        <el-select clearable   v-model="formInline.operatorUserId" placeholder="请选择">
    <el-option
   
      v-for="item in SelectList"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
      </el-form-item>



    


     

     
     
      <el-form-item prop="beginSendTime" label="发送时间:">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
            v-model="formInline.beginSendTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endSendTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"  default-time="['23:59:59']" type="datetime" placeholder="选择日期"
              v-model="formInline.endSendTime" style="width: 100%;"></el-date-picker>

          </el-form-item>

        </el-col>
      </el-form-item>


      <el-form-item>
        <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button  icon="el-icon-delete"  type="info"    @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->
      </el-form-item>
      <el-form-item>
      </el-form-item>
      <!-- <div style=" float: right; margin-right: 50px; margin-bottom: 0px; ">
        <el-button  type="success" icon="el-icon-plus" @click="addCogilg">发布活动</el-button>
      </div> -->
    </el-form>

    <!--列表-->
    <el-table id="educe-table"  ref="multipleTable" stripe :data="listData" highlight-current-row
      v-loading="loading" @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
      style="width: 100%; font-size: 18px;">

      </el-table-column>
      <!-- <el-table-column align="center" prop="userId" label="人员UID" width="100">
      </el-table-column> -->
      <el-table-column align="center" prop="userName" label="操作人员" width="200">
      </el-table-column>
      <el-table-column align="center" prop="accountId" label="接收者UID" width="200">
      </el-table-column>
      <el-table-column align="center" prop="nickName" label="接收者昵称" width="150">
      </el-table-column>
      <el-table-column align="center" prop="phone" label="接收者手机" width="150">
        <template slot-scope="scope">
          <div>{{ String(scope.row.phone).substring(0,3)+"****"+String(scope.row.phone).substring(7,4)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="noticeId" label="短信ID" width="100">
      </el-table-column>
      <el-table-column align="center" prop="content" label="发送内容" width="300">
      </el-table-column>
      <el-table-column prop="image" label="发送类型" width="180">
        <template slot-scope="scope">
            <span>{{scope.row.type==1?'系统通知':"短信发送"  }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="image" label="发送状态" width="180">
        <template slot-scope="scope">
            <span>{{scope.row.status==1?'成功':"失败"  }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="closeTime" label="发送时间" width="280">
        <template slot-scope="scope">
          <div v-if="scope.row.sendTimeMills">{{ scope.row.sendTimeMills | timestampToTime }}</div>
          <div v-else></div>
      
        </template>
      </el-table-column>
      <el-table-column prop="closeTime" label="送达时间" width="280">
        <template slot-scope="scope">
          <div v-if="scope.row.sendSuccessTimeMills">{{ scope.row.sendSuccessTimeMills | timestampToTime  }}</div>
          <div  v-else></div>
      
        </template>
      </el-table-column>
      <el-table-column align="center" prop="replyNum" label="回复数量" width="100">
      </el-table-column>
      <el-table-column prop="closeTime"  fixed="right" label="操作" width="100">
        <template slot-scope="scope">
            <el-button type="primary" v-if="scope.row.status==2" >重新发送</el-button>
     
      
        </template>
      </el-table-column>

     
      <!-- <el-table-column align="center" fixed="right" label="操作" min-width="250">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
          <el-button size="mini" type="success" @click="deleteUser(scope.row.id)">管理</el-button>
          <el-button v-if="scope.row.indexDesc ==0" size="mini" type="warning"
            @click="recommend(scope.$index, scope.row)">推荐</el-button>
          <el-button v-if="scope.row.indexDesc != 0" size="mini" type="info"
            @click="recommend(-1, scope.row)">取消推荐</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
      @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <!-- <div style="margin-top: 20px;">
      <el-button @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button @click="imporList" type="success">导出数据</el-button>

    </div> -->
    <el-dialog title="温馨提示" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">

        <span style="margin-left: 52px;">确定要将该活动推荐吗？</span><br>

        <el-form-item label="推荐排序" prop="deptName">
          <el-input style="width: 200px;"  type="number" v-model="recommendform.index" auto-complete="off"
            placeholder="请输入排序"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="closeDialog">取消</el-button>
        <el-button  type="primary" :loading="loading" class="title"
          @click="submitForm('editForm')">确定推荐</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Axios from 'axios'
import { login } from "../../api"
import { homeData } from '../../request/home'


import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      dialogVisible: false,
      value: "",
      options123: [],
      ssoServer:"",
      options1234123: [],
      aData: new Date(),

      adder: "",
      recommendform: {
        index: "",
        id: ""
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      SelectList:'',
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
    
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },

      // rules表单验证
      rules: {
        index: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        accountId:"",
        nickName:"",
        phone:"",
        beginSendTime:"",
        endSendTime:"",
        status:'',
        type:"",
        operatorUserId:'',
        // activityAddressCode: "",
        // activityType: "",//活动类型
        // activityStatus: "",//活动状态
        // indexType: "",//推荐状态
        // beginTime: "",//开始时间
        // endTime: "",//结束时间
        // createBeginTime: "",//创建开始时间
        // createEndTime: "",//创建结束时间
        // id: "",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    this.value=(new Date()).getTime();
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId
  },
  mounted() {
    this.formLIst()
    Axios({
        method: 'get',
        url: this.ssoServer+'/api/platform-user/getSelectList',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        this.SelectList =res.data.data

      })



  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    deleteUser(e){
      this.$router.push({
    path:"/Eventmanagement/activitiesDetail",
    query:{ //query是个配置项
        id:e
    }
})

    },
    // 推荐
    // getCurrentTime() {
    //     //获取当前时间并打印
    //     var _this = this;
    // let yy = new Date().getFullYear();
    // let mm = new Date().getMonth()+1;
    // let dd = new Date().getDate();
    // let hh = new Date().getHours();
    // let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    // let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    // _this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
    // console.log(_this.gettime)  
    // },
    recommend(i, f) {
      if (i == -1) {
        this.recommendform.id = f.id
        this.recommendform.index = 0

        this.$confirm('确定要将该活动推荐取消吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '取消成功'
              })
              this.formLIst()
            }
          })

        }).catch(() => {

        });
        return

      }else{
        this.editFormVisible = true

      }
      this.recommendform.id = f.id

     
      this.recommendform.index = ''

    },




    addCogilg() {
      this.$router.push({
        path: "/Eventmanagement/addActivities",

      })

    },
    selectall(val) {
      // console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      // console.log(val);
    },


    getAddress() {

      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',

        headers: {
          tokenId: this.adder
        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        // console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },


    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    selectalls(rows) {

      if (rows) {
        let data = []
        rows.forEach((item) => {
          data.push(item.id)
          this.importList = data
          console.log(this.importList);

        })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        console.log('1212112');
        this.importList = []

        this.$refs.multipleTable.clearSelection();//清除全选
      }


    },

    onChange(e) {

      this.formInline.activityAddressCode = e[1]
      // console.log( this.formInline.registerAddress);


    },
    selectall(val) {

      let data = []
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      console.log(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer+'/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList,
            searchType: 1
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
      //  this.formInline =''
      this.$refs[formInline].resetFields();
    },


    formLIst() {

      // let accountListReqVO= this.formInline
      Axios({
        method: 'get',

        url: this.ssoServer+'//api/notice/getList',
        headers: {
          tokenId: this.adder
        },
        params: this.formInline


      }).then(res => {
        console.log(res);
        if (res.data.code == 999) {
          setTimeout(() => {
        
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==500){
          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }
        this.listData = res.data.data.list

        this.pageparm.currentPage = this.formInline.current
        this.pageparm.pageSize = this.formInline.size
        this.pageparm.total = res.data.data.total
        // console.log(res);
      })

    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;
    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current = 1
      this.value=(new Date()).getTime();

      this.formLIst()
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.$router.push({
    path:"/Eventmanagement/Eventdetails",
    query:{ //query是个配置项
        id:row.id
    }
})
      
      // this.editFormVisible = true
      // if (row != undefined && row != 'undefined') {
      //   this.title = '修改'
      //   this.editForm.deptId = row.deptId
      //   this.editForm.deptName = row.deptName
      //   this.editForm.deptNo = row.deptNo
      // } else {
      //   this.title = '添加'
      //   this.editForm.deptId = ''
      //   this.editForm.deptName = ''
      //   this.editForm.deptNo = ''
      // }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.recommendform.index==''){
            return this.$message({
                type: 'warning',
                message: '推荐排序不能为空'
              })
          }
          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '推荐成功'
              })
              this.editFormVisible = false
              this.formLIst()

            }else{
              this.$message({
                type: 'warning',
                message: res.data.message
              })
              return

            }

        
          })
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/adminiStration/Sendrecords.vue